/**
 * Curated panel builtin icon catalogue helpers.
 * Catalogue is generated by scripts/generate_panel_icons.mjs.
 *
 * Renderer resolution order:
 *   1) curated panelIcons.json → /panel-icons/{filename}.png
 *   2) legacy launcherIcons.json → existing webp paths (saved layouts)
 * Picker UI uses curated panelIcons only.
 */

import panelIcons from './panelIcons.json';
import launcherIcons from './launcherIcons.json';

export const PANEL_ICONS_PUBLIC_BASE = '/panel-icons';

/** Full curated catalogue (generated). */
export { panelIcons };

/** id → /panel-icons/{filename} for curated preview rendering. */
export const PANEL_ICON_PATH_BY_ID = panelIcons.reduce((acc, it) => {
  if (it?.id && it?.filename) {
    acc[it.id] = `${PANEL_ICONS_PUBLIC_BASE}/${it.filename}`;
  }
  return acc;
}, /** @type {Record<string, string>} */ ({}));

/** Legacy HomeLauncher webp catalogue (renderer fallback only). */
const LEGACY_ICON_PATH_BY_ID = (launcherIcons || []).reduce((acc, it) => {
  if (it?.id && it?.path) {
    acc[it.id] = it.path;
  }
  return acc;
}, /** @type {Record<string, string>} */ ({}));

/**
 * Resolve a preview path for an iconKey.
 * Prefers curated panel PNGs; falls back to legacy launcherIcons for
 * existing saved layouts that still reference old keys.
 *
 * @param {string|null|undefined} iconKey
 * @returns {string|undefined}
 */
export function getPanelIconPath(iconKey) {
  if (!iconKey) return undefined;
  const key = String(iconKey);
  return PANEL_ICON_PATH_BY_ID[key] || LEGACY_ICON_PATH_BY_ID[key];
}

/**
 * @param {{id?: string, label?: string, name?: string, filename?: string}} entry
 * @returns {string}
 */
export function getPanelIconLabel(entry) {
  if (!entry) return '';
  return entry.label || entry.name || entry.id || '';
}

/**
 * Preview path for an icon entry (picker / img src).
 * @param {{id?: string, filename?: string, path?: string}} entry
 * @returns {string}
 */
export function getPanelIconEntryPath(entry) {
  if (!entry) return '';
  if (entry.path) return entry.path;
  if (entry.filename) return `${PANEL_ICONS_PUBLIC_BASE}/${entry.filename}`;
  if (entry.id) {
    // Prefer curated path for known panel ids; do not consult legacy here so
    // picker entries always point at /panel-icons when possible.
    return PANEL_ICON_PATH_BY_ID[String(entry.id)] || '';
  }
  return '';
}
